module.exports = __webpack_public_path__ + "img/level_four.8c00c8a3.png";